module.exports = __webpack_public_path__ + "media/images/pic/teachers/miho-takahashi-bd5067f46fd8df8709dba3aa654e5188.webp";